var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 46,
    rx: 8,
    fill: "#035CF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10273_4126",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 14,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H28V32H10V14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10273_4126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.875 19.25H11.5C10.4659 19.25 9.625 20.0909 9.625 21.125V30.5C9.625 31.5341 10.4659 32.375 11.5 32.375H20.875C21.9091 32.375 22.75 31.5341 22.75 30.5V21.125C22.75 20.0909 21.9091 19.25 20.875 19.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13.625H17.125C16.6277 13.625 16.1508 13.8225 15.7992 14.1742C15.4475 14.5258 15.25 15.0027 15.25 15.5V17.375H22.75C23.2473 17.375 23.7242 17.5725 24.0758 17.9242C24.4275 18.2758 24.625 18.7527 24.625 19.25V26.75H26.5C26.9973 26.75 27.4742 26.5525 27.8258 26.2008C28.1775 25.8492 28.375 25.3723 28.375 24.875V15.5C28.375 15.0027 28.1775 14.5258 27.8258 14.1742C27.4742 13.8225 26.9973 13.625 26.5 13.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCopy);
export default __webpack_public_path__ + "static/media/btn_copy.bf6be2e0fd691ca322709d5d877dde12.svg";
export { ForwardRef as ReactComponent };